// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"8444ecaf","79":"5cea99a1","735":"f5076cf9"}[chunkId] + ".chunk.css";
};